import * as z from "zod/v4";
import { LocationInputSchema } from "./add-location";

export const updateLocation = {
  name: "updateLocation" as const,
  input: LocationInputSchema.extend({ locationId: z.string() }),
  output: z.union([
    z.object({ success: z.literal(true) }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
